import * as React from 'react';

import { mergeStyles, Popup, TextField } from '@cian/components';
import { Button } from '../../../../common/components/button';
import { ModalWrapper } from '../../../../common/components/modal/wrapper';
import { Textarea } from '../../../../common/components/textarea';
import { validateEmailFormat } from '../../../../utils/format';
import { IMakeRequest } from '../../../../utils/request';

const style = require('./index.css');

export interface IFeedbackPopupProps {
  makeRequest: IMakeRequest;
  userEmail: string | undefined;

  onClose(): void;
}

export interface IFeedbackPopupState {
  email: string;
  emailInvalid: boolean;
  comment: string;
  commentInvalid: boolean;

  isLoading: boolean;
  isDone: boolean;
}

export class FeedbackPopup extends React.Component<IFeedbackPopupProps, IFeedbackPopupState> {
  private textfield: TextField | null = null;
  private textarea: Textarea | null = null;

  public constructor(props: IFeedbackPopupProps) {
    super(props);

    this.state = {
      email: props.userEmail || '',
      emailInvalid: false,
      comment: '',
      commentInvalid: false,

      isLoading: false,
      isDone: false,
    };
  }

  public componentDidMount() {
    const { email } = this.state;

    if (this.textfield && this.textarea) {
      if (!email) {
        this.textfield.focus();
      } else {
        this.textarea.focus();
      }
    }
  }

  public render() {
    const { onClose } = this.props;
    const { email, emailInvalid, comment, commentInvalid, isLoading, isDone } = this.state;

    return (
      <ModalWrapper containerStyle={style['container']} onClose={() => !isLoading && onClose()}>
        <Popup containerStyle={style['popup']}>
          <button className={style['popup-close']} onClick={onClose} disabled={isLoading}></button>
          <h3 className={style['popup-title']}>Поделитесь вашим мнением о ЦИАН</h3>
          {!isDone && (
            <form action="#" onSubmit={this.handleFormSubmit}>
              <TextField
                ref={textfield => (this.textfield = textfield)}
                containerStyle={style['popup-textfield']}
                type="email"
                placeholder="Email"
                value={email}
                disabled={isLoading}
                invalid={emailInvalid}
                onValueChange={this.handleEmailChange}
              />
              <Textarea
                ref={textarea => (this.textarea = textarea)}
                {...mergeStyles(style['popup-textarea'], commentInvalid && style['popup-textarea--invalid'])}
                placeholder="Отзыв"
                value={comment}
                disabled={isLoading}
                onValueChange={this.handleCommentChange}
              />
              <Button theme="primary" type="submit" disabled={isLoading}>
                Отправить
              </Button>
            </form>
          )}
          {isDone && <div>Спасибо за ваш отзыв!</div>}
        </Popup>
      </ModalWrapper>
    );
  }

  private handleEmailChange = (value: string) => {
    this.setState({
      email: value,
      emailInvalid: false,
    });
  };

  private handleCommentChange = (value: string) => {
    this.setState({
      comment: value,
      commentInvalid: false,
    });
  };

  private handleFormSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    const { makeRequest } = this.props;
    const { email, comment } = this.state;

    this.setState({
      isLoading: true,
    });

    const emailValid = validateEmailFormat(email);

    if (!email || !emailValid || !comment) {
      this.setState({
        emailInvalid: !emailValid,
        commentInvalid: !comment,
        isLoading: false,
      });

      return;
    }

    makeRequest({
      uri: {
        path: '/ajax/feedback',
      },
      headers: [['Content-Type', 'application/x-www-form-urlencoded']],
      body:
        `source=newsearchform` +
        `&email=${encodeURIComponent(email)}` +
        `&text=${encodeURIComponent(comment)}` +
        `&url=${encodeURIComponent(window.location.href)}` +
        `&ua=${encodeURIComponent(window.navigator.userAgent)}` +
        `&width=${window.innerWidth}` +
        `&height=${window.innerHeight}`,
      method: 'POST',
    })
      .then((response: { status: string }) => {
        this.setState({
          isLoading: false,
          isDone: true,
        });
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          commentInvalid: true,
        });
      });
  };
}
